import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router (SPA) navigation doesn't trigger a full page reload, so the
 * browser preserves scroll position across route changes by default. This
 * resets it to the top on every navigation, mounted once inside <Router>.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // On mobile, #root (not the window) is the real scroll container - see
    // the #root rules in index.css.
    document.getElementById('root')?.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
